/* tilen premium-design (20/10-2026): forventet leveringsdato og rolig fade-in ved scroll. */
(function () {
  var dage = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
  var mdr = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];

  function hverdag(d) {
    var w = d.getDay();
    if (w === 6) d.setDate(d.getDate() + 2);
    if (w === 0) d.setDate(d.getDate() + 1);
    return d;
  }
  function om(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + n);
    return hverdag(d);
  }
  function fmt(d, medMaaned) {
    return dage[d.getDay()] + ' ' + d.getDate() + '.' + (medMaaned ? ' ' + mdr[d.getMonth()] : '');
  }
  function levering(root) {
    (root || document).querySelectorAll('.tilen-levering').forEach(function (el) {
      var mn = parseInt(el.dataset.min, 10), mx = parseInt(el.dataset.max, 10);
      var v = el.querySelector('.tilen-levering__vaerdi');
      if (!mn || !mx || !v) return;
      var a = om(mn), b = om(mx);
      v.textContent = fmt(a, a.getMonth() !== b.getMonth()) + ' til ' + fmt(b, true);
    });
  }

  function reveal() {
    // Forsidens fliser og tekst i fliserne får samme rolige fade-in som fortællingen.
    document.querySelectorAll('.tilen-flise__tekst').forEach(function (el) { el.classList.add('tilen-reveal'); });
    var els = document.querySelectorAll('.tilen-reveal');
    if (!els.length) return;
    var stille = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (stille || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('tilen-reveal-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0.01 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  // Lydløse videoer (fx laseren i "Graveret i ægte træ") spiller kun, mens de ses, og aldrig ved reduceret bevægelse.
  function autoplay() {
    var vids = document.querySelectorAll('video[data-tilen-autoplay]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  // Popuppen mens tegningen laves (snippets/tilen-vent.liquid). Bjælken nærmer sig roligt 92 % ud fra den forventede tid
  // og fylder op, når tegningen er færdig. Teksten siger altid "Ca. 1 minut" fra start (ejeren 3/11-2026), og "Lige om lidt", når minuttet er gået.
  // Køens tid (data-eta) styrer kun bjælkens tempo.
  function ventetid() {
    var busy = document.querySelector('[data-race-busy]'), vent = document.querySelector('[data-tilen-vent]');
    if (!busy || !vent) return;
    var fyld = vent.querySelector('[data-tilen-vent-fyld]'), bar = vent.querySelector('[role="progressbar"]');
    var linje = vent.querySelector('[data-vent-status]'), tid = vent.querySelector('[data-vent-tid]'), tekst = busy.querySelector('[data-race-busytext]');
    var t0 = 0, tau = 26, timer = null, aktiv = false;
    function saet(p) {
      fyld.style.transform = 'scaleX(' + p.toFixed(3) + ')';
      bar.setAttribute('aria-valuenow', Math.round(p * 100));
    }
    function tik() {
      var sek = (Date.now() - t0) / 1000, l = sek < 15 ? 'Vi forvandler dit billede til et personligt træportræt' : 'Vi arbejder på de fine detaljer';
      tau = Math.max(tau, (parseInt(vent.dataset.eta, 10) || 60) / 2.3);
      saet(0.92 * (1 - Math.exp(-sek / tau)));
      if (linje.textContent !== l) { linje.textContent = l; if (tekst) tekst.textContent = l; }
      tid.textContent = sek < 60 ? 'Ca. 1 minut' : 'Lige om lidt';
    }
    function start() {
      aktiv = true; t0 = Date.now(); tau = 26; linje.textContent = '';
      tik(); timer = setInterval(tik, 500);
    }
    function stop() {
      if (!aktiv) return;
      aktiv = false; clearInterval(timer); saet(1);
    }
    function tjek() {
      var ai = !busy.hidden && busy.hasAttribute('data-ai');
      if (ai && !aktiv) start(); else if (!ai && aktiv) stop();
    }
    new MutationObserver(tjek).observe(busy, { attributes: true, attributeFilter: ['hidden', 'data-ai'] });
    tjek();
  }

  function start() { levering(); reveal(); autoplay(); ventetid(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { levering(e.target); });
})();
